













import Vue from 'vue'
import { oneOf } from '@/utils/helper'

// member exportをvueから切り分けるとともに、gulpでconvertしたvueファイルから絶対パスで参照できるようにするハック
import { SelectOption } from '@/components/shared/atoms/Select'

export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as () => SelectOption[],
      default: () => []
    },
    placeholder: {
      type: String,
      default: '選択してください'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    errors: {
      type: Array as () => string[],
      default: () => []
    },
    outputType: {
      type: String,
      default: 'string',
      validator: oneOf(['string', 'number'])
    },
    unsetNullOption: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary',
      validator: oneOf(['primary', 'secondary'])
    },
    size: {
      type: String,
      default: 'md',
      validator: oneOf(['sm', 'md'])
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    translatedValue(): string | null {
      return typeof this.value === 'string' ? this.value : this.stringify(this.value)
    },
    selectOptions(): SelectOption[] {
      return this.unsetNullOption ? [...this.options] : [{ value: null, text: this.placeholder }, ...this.options]
    },
    hasError(): boolean {
      return this.errors.length > 0
    },
    setClass(): string {
      return this.type
    },
    sizeClassName(): string {
      return `-${this.size}`
    }
  },
  methods: {
    handleInput(e: { target: { value: string } }): void {
      const value = e.target.value

      this.$emit('input', this.outputType === 'number' ? this.numerify(value) : value)
    },
    handleChange(e: { target: { value: string } }): void {
      const value = e.target.value

      this.$emit('input', this.outputType === 'number' ? this.numerify(value) : value)
      this.$emit('change', this.outputType === 'number' ? this.numerify(value) : value)
    },
    stringify(val: number | null): string | null {
      return val === null ? null : String(val)
    },
    numerify(val: string | null): number | null {
      return !val ? null : parseInt(val, 10)
    }
  }
})
